// Generated by purs version 0.14.4
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var AccountId = function (x) {
    return x;
};
var udecodeAccountId = Unscramble.decode_Int;
var showAccountId = Data_Show.showInt;
var ordAccountId = Data_Ord.ordInt;
var newtypeAccountId = {
    Coercible0: function () {
        return undefined;
    }
};
var eqAccountId = Data_Eq.eqInt;
var encodeAccountId = Foreign_Generic_Class.intEncode;
var decodeAccountId = Foreign_Generic_Class.intDecode;
export {
    AccountId,
    newtypeAccountId,
    showAccountId,
    eqAccountId,
    ordAccountId,
    encodeAccountId,
    decodeAccountId,
    udecodeAccountId
};
//# sourceMappingURL=index.js.map
